// Guided-tour "seen" marker — "has this device been offered the tour", per
// device (pre-sync).
//
// The gate that keeps the tour from being pushy (owner constraint #2): once the
// author declines, dismisses, or finishes the tour, the offer must NOT reappear
// on later visits. Like the theme, the display name and the last-visit marker,
// this is DEVICE UX state, not a domain fact (memory
// project_theme_outside_event_log): it round-trips through localStorage and is
// never emitted as an event; when the sync substrate lands, a per-device
// "seen" marker stays local by design. Only the impure shell (AppShellHost)
// calls `readTourSeen` / `markTourSeen`; the parse/serialize pair is pure.
//
// Parse, don't validate (the lastVisit.ts pattern): localStorage hands back
// `string | null` written by ANY earlier build. Anything absent or malformed
// degrades to "not seen" (the offer may show) — never a crash.

import { readDeviceKey, writeDeviceKey } from "./deviceStore.js";

// Namespaced key, matching the `theme` / `viewState` / `lastVisit` convention.
const STORAGE_KEY = "bilda.tourSeen";

// --- Parsing (pure) ----------------------------------------------------------

export const parseTourSeen = (raw: string | null): boolean => raw === "true";

// --- Serializing (pure) ------------------------------------------------------

export const serializeTourSeen = (seen: boolean): string =>
    seen ? "true" : "false";

// --- The impure seam (host-only, like lastVisit.ts) --------------------------

export const readTourSeen = (): boolean =>
    parseTourSeen(readDeviceKey(STORAGE_KEY));

export const markTourSeen = (): void =>
    writeDeviceKey(STORAGE_KEY, serializeTourSeen(true));
